var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"h-100"},[_c('library-selector',{attrs:{"name":"Tools"}}),_c('v-container',{staticClass:"tools-container",attrs:{"grid-list-xs":""}},[(!_vm.plant_id || !_vm.library_id)?_c('library-selector-card',{attrs:{"name":"Tools"}}):_vm._e(),_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }